import { from, Observable } from 'rxjs';

import { DocumentType } from '../enums';

// Pure document helpers with no Angular/component dependencies. DocumentViewerComponent uses
// these directly instead of injecting DocumentUtility, which itself opens DocumentViewerComponent
// (importing each other would be a circular dependency).

declare const Tiff: any;

async function fetchImage(url: string): Promise<ArrayBuffer> {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch image: ${response.statusText}`);
  }

  return response.arrayBuffer();
}

function processTiff(buffer: ArrayBuffer): string[] {
  const pages: string[] = [];
  const tiff = new Tiff({ buffer });

  for (let i = 0; i < tiff.countDirectory(); i++) {
    tiff.setDirectory(i);

    const canvas = tiff.toCanvas();

    pages.push(canvas.toDataURL('image/png'));
    canvas.remove();
  }

  return pages;
}

async function processImageAsync(path: string, url: string): Promise<string[]> {
  try {
    const buffer = await fetchImage(url);

    if (/\.(tiff|tif)$/i.test(path)) {
      return processTiff(buffer);
    } else return [url];
  } catch (err) {
    // TODO: Handle error gracefully
  }
}

export function processDocumentImage(path: string, url: string): Observable<string[]> {
  return from(processImageAsync(path, url));
}

export function getDocumentName(path: string): string {
  return path ? path.substring(path.lastIndexOf('/') + 1) : '';
}

export function getDocumentType(src: string): DocumentType {
  // Check for base64-encoded content
  if (src.startsWith('data:')) {
    const mime = src.split(';')[0].replace('data:', '');

    if (mime.startsWith('image/')) return DocumentType.IMG;
    if (mime === 'application/pdf') return DocumentType.PDF;
  }

  // Check file extensions for standard URLs
  if (/\.(jpeg|jpg|png|gif|bmp|svg|webp|tiff|tif)$/i.test(src)) return DocumentType.IMG;
  if (/\.pdf$/i.test(src)) return DocumentType.PDF;
}
